module.exports = __webpack_public_path__ + "static/img/SZ.e9dcc40d.svg";